import { Alert, AlertTitle, Typography, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { getFunction } from 'expression/builder/Functions';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  tip: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    marginTop: 40,
    padding: '0px 12px 12px',
    alignSelf: 'center',
  },
  alert: {
    marginTop: 12,
  },
}));

type Props = {
  category: string;
  funOrProperty: string;
};

export const FunctionOrPropertyTip = ({ category, funOrProperty }: Props) => {
  const funcOrPropertyObject = getFunction(category, funOrProperty);

  if (!funcOrPropertyObject) return null;

  return <Tip {...funcOrPropertyObject} />;
};

type TipProps = {
  name: string;
  displayName?: string;
  description?: string;
  usage?: string;
  example?: string;
};

const Tip = ({ name, displayName, description, usage, example }: TipProps) => {
  const classes = useStyles();
  if (!(description || displayName)) return null;
  return (
    <div className={classes.tip}>
      <Typography variant="h6">{displayName || name}</Typography>
      <Typography variant="body1" paragraph>
        {description}
      </Typography>
      {usage ? (
        <Alert className={classes.alert} severity="info">
          <AlertTitle>Usage</AlertTitle>
          {usage}
        </Alert>
      ) : null}
      {example ? (
        <Alert className={classes.alert} severity="success">
          <AlertTitle>Example</AlertTitle>
          {example}
        </Alert>
      ) : null}
    </div>
  );
};

export default Tip;
